import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/contactus.scss";

const initialForm = {
  name: "",
  email: "",
  orderNumber: "",
  topic: "Other request",
  message: "",
  website: "",
};

function Contact() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState({ type: "idle", message: "" });

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const submitRequest = async (event) => {
    event.preventDefault();
    setStatus({ type: "submitting", message: "Sending your request…" });

    try {
      const response = await fetch("/contact_request.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(result.message || "We could not send your request.");
      }

      setForm(initialForm);
      setStatus({
        type: "success",
        message: "Thank you. Your request has been sent to our support team.",
      });
    } catch (error) {
      setStatus({
        type: "error",
        message: `${error.message} Please email import@cewillowmarket.life if the problem continues.`,
      });
    }
  };

  return (
    <div className="contact-page">
      <div className="container">
        <h1>Contact</h1>
        <p className="intro">
          We're here to help with product questions, existing orders and other
          requests.
        </p>

        <div className="contact-layout">
          <div className="info-section">
            <div className="contact-item">
              <h4>Email:</h4>
              <p>
                <a href="mailto:import@cewillowmarket.life">
                  import@cewillowmarket.life
                </a>
              </p>
            </div>

            <div className="contact-item">
              <h4>Company:</h4>
              <p>Hong Kong Mousheng Tech Limited</p>
              <p>
                FLAT 1506, 15/F, CHEUNG FUNG COMM BLDG,<br />
                21-25 CHEUNG SHA WAN ROAD,<br />
                SHAM SHUI PO, HONG KONG
              </p>
            </div>
          </div>

          <form className="contact-form" onSubmit={submitRequest}>
            <h2>Send a request</h2>

            <div className="contact-form__row">
              <label>
                Name <span aria-hidden="true">*</span>
                <input name="name" value={form.name} onChange={updateField} autoComplete="name" maxLength="100" required />
              </label>
              <label>
                Email <span aria-hidden="true">*</span>
                <input type="email" name="email" value={form.email} onChange={updateField} autoComplete="email" maxLength="160" required />
              </label>
            </div>

            <div className="contact-form__row">
              <label>
                Request type <span aria-hidden="true">*</span>
                <select name="topic" value={form.topic} onChange={updateField} required>
                  <option>Product question</option>
                  <option>Order support</option>
                  <option>Return or exchange</option>
                  <option>Delivery question</option>
                  <option>Other request</option>
                </select>
              </label>
              <label>
                Order number <small>(optional)</small>
                <input name="orderNumber" value={form.orderNumber} onChange={updateField} maxLength="80" />
              </label>
            </div>

            <label>
              How can we help? <span aria-hidden="true">*</span>
              <textarea name="message" value={form.message} onChange={updateField} rows="7" maxLength="4000" required />
            </label>

            <label className="contact-form__honeypot" aria-hidden="true">
              Website
              <input name="website" value={form.website} onChange={updateField} tabIndex="-1" autoComplete="off" />
            </label>

            <p className="contact-form__privacy">
              We use these details only to respond to your request. See our{" "}
              <Link to="/privacy">Privacy Policy</Link>.
            </p>

            <button type="submit" disabled={status.type === "submitting"}>
              {status.type === "submitting" ? "Sending…" : "Submit request"}
            </button>

            {status.message && (
              <p className={`contact-form__status is-${status.type}`} role="status" aria-live="polite">
                {status.message}
              </p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default Contact;
